import { render, staticRenderFns } from "./DistribucionPagoPTIv5.vue?vue&type=template&id=49a97b93&scoped=true"
import script from "./DistribucionPagoPTIv5.vue?vue&type=script&lang=js"
export * from "./DistribucionPagoPTIv5.vue?vue&type=script&lang=js"
import style0 from "./DistribucionPagoPTIv5.vue?vue&type=style&index=0&id=49a97b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a97b93",
  null
  
)

export default component.exports